// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.client-actions {
  display: flex;
  gap: 0.75rem;
}
.client-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}
.client-actions button.btn-update {
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
}
.client-actions button.btn-update:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-actions button.btn-delete {
  background-color: var(--danger-light-bg);
  color: var(--danger-color);
}
.client-actions button.btn-delete:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.expense-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.expense-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

.expense-header {
  display: flex;
  align-items: flex-start; /* Aligns items to the top */
  justify-content: space-between; /* Pushes children to opposite ends */
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1.5rem;
}
.expense-header .expense-header-data {
  display: flex;
  align-items: center; /* Vertically aligns the avatar and title */
  gap: 1.5rem; /* Adds space between avatar and title */
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  /* margin-right: 1.5rem;  <-- This line is removed */
}

.expense-title h2 {
  margin: 0;
  font-size: 1.3rem;
  color: var(--text-dark);
  font-weight: 600;
}

.expense-tag {
  display: inline-block;
  margin-top: 0.5rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
}

.expense-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 0.8rem;
  margin-bottom: 1.5rem;
}

.exp-detail-item {
  display: flex;
  gap: 1rem;
}
.exp-detail-item .icon {
  font-size: 1.25rem;
  color: var(--primary-color);
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.exp-detail-item label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: var(--text-light);
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.exp-detail-item p {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-dark);
}

.exp-desc p {
  font-weight: 400 !important;
  line-height: 1.4rem !important;
}

.expense-description {
  font-size: 0.95rem;
  color: var(--text-medium);
  margin-bottom: 1rem;
}

.expense-document a {
  font-weight: 500;
  color: var(--primary-color);
  text-decoration: underline;
}
.expense-document a:hover {
  text-decoration: none;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.error-message {
  text-align: center;
  color: var(--danger-color);
  font-weight: 500;
  font-size: 1rem;
  padding: 2rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .expense-detail-container {
    padding: 1rem;
  }
  .expense-card {
    padding: 1.5rem;
  }
  .expense-details-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ExpenseView/ExpenseView.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AACJ;AACI;EACE,yCAAA;EACA,2BAAA;AACN;AACM;EACE,YAAA;EACA,2BAAA;AACR;AAGI;EACE,wCAAA;EACA,0BAAA;AADN;AAGM;EACE,YAAA;EACA,2BAAA;AADR;;AAOA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AAJF;;AAOA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AAJF;;AAQA;EACE,aAAA;EACA,uBAAA,EAAA,4BAAA;EACA,8BAAA,EAAA,qCAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AALF;AAOE;EACE,aAAA;EACA,mBAAA,EAAA,2CAAA;EACA,WAAA,EAAA,wCAAA;AALJ;;AASA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oDAAA;AANF;;AAUE;EACE,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,qBAAA;EACA,kBAAA;EACA,sCAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;AARF;;AAWA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,qBAAA;AARF;;AAYA;EACE,aAAA;EACA,SAAA;AATF;AAWE;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AATJ;AAYE;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;AAVJ;AAaE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAXJ;;AAgBE;EACA,2BAAA;EACA,8BAAA;AAbF;;AAiBA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;AAdF;;AAkBE;EACE,gBAAA;EACA,2BAAA;EACA,0BAAA;AAfJ;AAgBI;EACE,qBAAA;AAdN;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AAhBF;;AAmBA;EACE;IACE,yBAAA;EAhBF;AACF;AAmBA;EACE;IACE,aAAA;EAjBF;EAoBA;IACE,eAAA;EAlBF;EAqBA;IACE,0BAAA;EAnBF;AACF","sourcesContent":[":root {\r\n  --primary-light: #eef2ff;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --text-dark: #1f2937;\r\n  --text-medium: #4b5563;\r\n  --text-light: #9ca3af;\r\n  --bg-light: #f9fafb;\r\n  --card-bg: #ffffff;\r\n  --border-radius: 12px;\r\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n  --transition: all 0.3s ease;\r\n}\r\n\r\n.client-actions {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n\r\n  button {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n\r\n    &.btn-update {\r\n      background-color: var(--primary-light-bg);\r\n      color: var(--primary-color);\r\n\r\n      &:hover {\r\n        opacity: 0.9;\r\n        transform: translateY(-1px);\r\n      }\r\n    }\r\n\r\n    &.btn-delete {\r\n      background-color: var(--danger-light-bg);\r\n      color: var(--danger-color);\r\n\r\n      &:hover {\r\n        opacity: 0.9;\r\n        transform: translateY(-1px);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.expense-detail-container {\r\n  padding: 1rem;\r\n  background-color: #f4f6f8;\r\n  display: flex;\r\n}\r\n\r\n.expense-card {\r\n  background-color: var(--card-bg);\r\n  border-radius: var(--border-radius-primary);\r\n  box-shadow: var(--box-shadow);\r\n  width: 100%;\r\n  padding: 2rem;\r\n  // transition: var(--transition);\r\n}\r\n\r\n.expense-header {\r\n  display: flex;\r\n  align-items: flex-start; /* Aligns items to the top */\r\n  justify-content: space-between; /* Pushes children to opposite ends */\r\n  margin-bottom: 2rem;\r\n  border-bottom: 1px solid #eee;\r\n  padding-bottom: 1.5rem;\r\n\r\n  .expense-header-data {\r\n    display: flex;\r\n    align-items: center; /* Vertically aligns the avatar and title */\r\n    gap: 1.5rem; /* Adds space between avatar and title */\r\n  }\r\n}\r\n\r\n.avatar {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.75rem;\r\n  font-weight: bold;\r\n  /* margin-right: 1.5rem;  <-- This line is removed */\r\n}\r\n\r\n.expense-title {\r\n  h2 {\r\n    margin: 0;\r\n    font-size: 1.3rem;\r\n    color: var(--text-dark);\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.expense-tag {\r\n  display: inline-block;\r\n  margin-top: 0.5rem;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n}\r\n\r\n.expense-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 0.8rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n\r\n.exp-detail-item {\r\n  display: flex;\r\n  gap: 1rem;\r\n\r\n  .icon {\r\n    font-size: 1.25rem;\r\n    color: var(--primary-color);\r\n    margin-top: 0.25rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    color: var(--text-light);\r\n    letter-spacing: 0.5px;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    color: var(--text-dark);\r\n  }\r\n  \r\n}\r\n.exp-desc{\r\n  p{\r\n  font-weight: 400 !important;\r\n  line-height: 1.4rem !important;\r\n  }\r\n}\r\n\r\n.expense-description {\r\n  font-size: 0.95rem;\r\n  color: var(--text-medium);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.expense-document {\r\n  a {\r\n    font-weight: 500;\r\n    color: var(--primary-color);\r\n    text-decoration: underline;\r\n    &:hover {\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid rgba(67, 97, 238, 0.2);\r\n  border-top-color: var(--primary-color);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.error-message {\r\n  text-align: center;\r\n  color: var(--danger-color);\r\n  font-weight: 500;\r\n  font-size: 1rem;\r\n  padding: 2rem;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .expense-detail-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .expense-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .expense-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
